import styled, { css } from 'styled-components';

export const InputSelectContainer = styled.div`
  position: relative;
`;

export const Button = styled.button<{ isActive?: boolean }>`
  ${({ isActive = false }) => css`
    position: relative;
    padding: 8px 16px;
    background-color: ${isActive ? '#eeeeee' : 'transparent'};
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    color: #364856;
    line-height: 10px;
    border: 1px solid #11465d;
    border-radius: 6px;
    min-width: 200px;
    &:hover {
      background-color: #eeeeee;
    }
  `}
`;

export const List = styled.ul`
  position: absolute;
  background-color: white;
  top: 35px;
  box-shadow: 0px 0px 6px 6px rgba(0, 0, 0, 0.2);
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 100%;
  border-radius: 6px;
  z-index: 6;
`;

export const ListItem = styled.li<{ isSelected?: boolean }>`
  ${({ isSelected = false }) => css`
    cursor: pointer;
    border-radius: 10px;
    padding: 4px;
    width: calc(100% - 8px);
    background-color: ${isSelected ? '#D9D9D9' : 'transparent'};
    &:hover {
      background-color: #eeeeee;
    }
  `}
`;
